<div
  class="payment-method-mode-container"
  [ngClass]="{
    'payment-method-mode-container-selected': paymentMethodModeIsSaved$ | async,
    'payment-method-mode-container-expanded': savedPaymentMethodAutocompleteOpen$ | async
  }"
  (click)="paymentMethodModeChange.emit(PaymentMethodMode.SAVED)"
  data-cy="payment-method-mode-container-saved"
>
  <label class="mb-1 w-fit-content">Saved payment method</label>
  <auto-complete
    [formControl]="selectedSavedPaymentMethodControl"
    [options]="savedPaymentMethods$ | async"
    [compareToFn]="compareSavedPaymentMethodsFn"
    [triggerDisplayFn]="savedPaymentMethodDisplayFn"
    [sortFn]="sortSavedPaymentMethodsFn"
    [disableOptionFn]="disablePaymentMethodFn"
    [customPanelWidth]="panelWidth$ | async"
    [dismissPanel$]="dismissSavedPaymentMethodPanel$"
    customPanelClass="saved-payment-methods-autocomplete"
    (open)="savedPaymentMethodAutocompleteOpen$.next($event)"
    data-cy="saved-payment-methods-autocomplete"
  ></auto-complete>
</div>

<ng-container *ngIf="selectedSavedPaymentMethod$ | async as selectedSavedPaymentMethod">
  <ng-container *ngIf="selectedSavedPaymentMethod.billingDetailsIncomplete">
    <p class="small-300 color-red-300 mt-2">
      Please update the billing address for the card ending in {{ (selectedSavedPaymentMethod$ | async).lastFour }}.
    </p>

    <button
      andButton
      size="small"
      color="hyperlink"
      class="color-red-300 mt-1 mb-5 px-0"
      (click)="updateBillingAddress.emit(selectedSavedPaymentMethod$.value)"
      data-cy="update-billing-address-button"
    >
      Update billing address
    </button>
  </ng-container>
</ng-container>
